var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg px-5 py-3 ma-0 h-100",attrs:{"elevation":"0"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h4',[_vm._v(_vm._s(_vm.textValue))]),_c('h5',{staticClass:"font-weight-light text-capitalize"},[_c('b',[_vm._v(" "+_vm._s(_vm.text))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }